import { SxProps } from "@mui/material";

export const textFieldErrorSx: SxProps = {
  paddingBottom: 2,
  "& p": {
    position: "absolute",
    bottom: -10,
    left: 0,
  },
};
